module.exports = __webpack_public_path__ + "img/monitor.e4355943.png";